import api from "./api";

const VehicleHireReportService = {
  getReport: async (params) => {
    const response = await api.get("/vehicleHireReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        vehicleTypeId: params.vehicleTypeId || undefined,
        leaseTypeId: params.leaseTypeId || undefined,
        fuelBorneBy: params.fuelBorneBy || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,

        // ✅ ADD THESE (CRITICAL FIX)
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default VehicleHireReportService;